import { createRouter, createWebHistory } from 'vue-router';
import ROUTES from 'routes';

import LndAreasOfWork from 'components/LndAreasOfWork';
import LndCases from 'components/LndCases';
import LndAbout from 'components/LndAbout';
import PrivacyPage from 'components/PrivacyPage';

import { scroll } from 'services/scroll';
import { GA } from 'services/GTM';
// const PREVENT_SCROLL = { meta: { preventResetScroll: true } };

const routes = [
  // VueRoute('', ROUTES.ROOT, Landing),
  VueRoute('Abous Us', ROUTES.ABOUT, LndAbout),
  VueRoute('Out Cases', ROUTES.CASES, LndCases),
  VueRoute('Services', ROUTES.SERVICES, LndAreasOfWork),
  VueRoute('Privacy Policy', ROUTES.PRIVACY, PrivacyPage),
];

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes,

  scrollBehavior (to, from, saved) {
    if (to.meta.preventResetScroll)
      return;

    scroll(saved?.top || 0);
  },
});

router.afterEach((to, from) => {
  if (from.name !== to.name)
    GA.setPage(to.path);
});

export default router;

function VueRoute (title, path, component, opts) {
  return {
    path,
    name: path,
    title,
    component,
    ...opts,
  };
}
